import { styled } from "simplydo/react/styled";

import type { UISize } from "../utils/UIContext";
import { SIZE_FONT } from "../utils/colors";

const popupFontSize = (size?: UISize): string =>
  size === "small"
    ? SIZE_FONT.small
    : size === "large"
      ? SIZE_FONT.large
      : "0.875em";

/**
 * Keep popups inside the viewport (matches Dropdown menu padding). The size
 * middleware in Popup.tsx narrows this further via
 * `--popup-available-width` when the trigger sits near a viewport edge.
 */
export const POPUP_AVAILABLE_WIDTH_VAR = "--popup-available-width";
const VIEWPORT_MAX_WIDTH = `var(${POPUP_AVAILABLE_WIDTH_VAR}, calc(100vw - 16px))`;

export const PopupSurface = styled.div<{
  $transparent?: boolean;
  $wide?: boolean | "very";
  $inverted?: boolean;
  $size?: UISize;
  $fluid?: boolean;
}>`
  display: block;
  z-index: 1900;
  position: absolute;
  box-sizing: border-box;
  width: fit-content;
  max-width: ${({ $fluid, $wide, $transparent }) => {
    if ($fluid || $transparent) {
      return VIEWPORT_MAX_WIDTH;
    }
    if ($wide === "very") {
      return `min(450px, ${VIEWPORT_MAX_WIDTH})`;
    }
    if ($wide) {
      return `min(300px, ${VIEWPORT_MAX_WIDTH})`;
    }
    return `min(200px, ${VIEWPORT_MAX_WIDTH})`;
  }};
  min-width: 0;
  font-size: ${({ $size }) => popupFontSize($size)};
  line-height: 1.2rem;
  color: ${({ $inverted }) =>
    $inverted ? "rgba(255, 255, 255, 0.9)" : "rgba(0, 0, 0, 0.87)"};
  word-wrap: break-word;

  border-radius: 0.3rem;
  padding: ${({ $transparent }) => ($transparent ? "0" : "0.833em 1em")};
  /* Only focused programmatically (tabIndex -1) as a focus-trap target. */
  outline: none;
  box-shadow: ${({ $transparent }) =>
    $transparent
      ? "none"
      : "0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15)"};
  border: ${({ $transparent, $inverted }) => {
    if ($transparent || $inverted) {
      return "none";
    }
    return "1px solid #d4d4d5";
  }};
  background: ${({ $transparent, $inverted }) =>
    $transparent ? "transparent" : $inverted ? "#1b1c1d" : "#ffffff"};
`;

export const PopupContentEl = styled.div`
  /* content wrapper */
`;
